import React, { useEffect, useState } from 'react';
import ModalBase from 'components/Tvendo/Common/ModalBase';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import { wsGetAll } from 'services/WService';
import Table from 'components/Table/Table';
import { formatDate } from 'hooks/Pipe';

function LogsFrozenFor(props) {
  const { model, setOpen, businessPartner } = props;
  const [logs, setLogs] = useState([]);

  async function getLogs() {
    let res = await wsGetAll(`base/business-partner/${businessPartner.id}/frozen-for-logs`);
    if (res.success) setLogs(res.data);
  }

  useEffect(() => {
    getLogs();
  }, []);

  return (
    <ModalBase
      title="Logs de activación/desactivación"
      model={model}
      setOpen={setOpen}
      hideSave
      fullWidth
      maxWidth="md"
    >
      <GridContainer>
        <GridItem xs={12}>
          <Table
            hover
            tableHeaderColor="warning"
            tableHead={['#', 'Tipo', 'Fecha', 'Usuario', 'Tipo', 'Solicitante', 'Comentario']}
            tableData={logs.map((log, index) => {
              let solicitante, tipo;
              switch (log.type) {
                case 'SELLER':
                  solicitante = log.seller?.SlpName || '-';
                  tipo = 'Vendedor';
                  break;
                case 'SUPERVISOR':
                  solicitante = log.supervisor?.name || '-';
                  tipo = 'Supervisor';
                  break;
                case 'USER':
                  solicitante = log.user?.name || '-';
                  tipo = 'Supervisor digital';
                  break;
              }
              return [
                index + 1,
                log.frozenFor === 'N' ? 'Reactivación' : 'Inactivación',
                formatDate(log.created_at),
                log.created_by?.name,
                tipo,
                solicitante,
                log.comment,
              ];
            })}
          />
        </GridItem>
      </GridContainer>
    </ModalBase>
  );
}

export default LogsFrozenFor;
